import * as React from "react";
import {Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem} from "reactstrap";
import {StickyHelpButtonPopup} from "@falcon/plugin-falcon-journey";
import {resourcesHelper} from "@falcon/services";
import {Link} from "react-router-dom";

export const DashboardNavbar = (props: any) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const toggle = () => setIsOpen(!isOpen);
    const isBritannia = resourcesHelper.THEME === "Britannia"
    const isAuthenticated = props.applicationGuard.isAuthenticated();
    const britanniaHelpUrl = isAuthenticated ? "/dashboard/help" : "https://www.britanniainsurance.co.uk/car-insurance/contact-us.html#complaints"

    return (
        <Navbar className="d-flex journey-header" expand="md">
            <div className="journey-header-background">
            <NavbarBrand>
                <a className="header-logo-link" id={`goTo${resourcesHelper.THEME}HomePage`} href={resourcesHelper.BRAND_URL} target="_blank">
                    <img className="flow-logo" src={`/${resourcesHelper.THEME}/img/brand-logo.png`} alt={`${resourcesHelper.THEME} logo icon`} tabIndex={0}/>
                </a>
            </NavbarBrand>
            <NavbarToggler onClick={toggle}/>
            <Collapse isOpen={isOpen} navbar>
                <Nav className="ml-auto flex-column-reverse flex-md-row pt-3 pt-md-0" navbar>
                    {isBritannia ? (
                        <NavItem>
                            <Link id="help" to={britanniaHelpUrl} aria-label="Help">Help</Link>
                        </NavItem>
                    ) : (
                        <StickyHelpButtonPopup>
                            <NavItem>
                                <span id="help">Help</span>
                            </NavItem>
                        </StickyHelpButtonPopup>
                    )
                    }
                    {isAuthenticated &&
                        <NavItem>
                            <span id="logout" role="link" tabIndex={0} onClick={props.logout} onKeyPress={props.logout}
                                  aria-label="Log out">Log out</span>
                        </NavItem>
                    }
                </Nav>
            </Collapse>
            </div>
        </Navbar>
    );
};
